import Axios from "axios";
var SupplierOrganService = (function () {
    function SupplierOrganService() {
    }
    SupplierOrganService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/list", { params: params });
    };
    SupplierOrganService.prototype.addSave = function (data) {
        return Axios.post("supplierclientapi/supplierorgan/create", data);
    };
    SupplierOrganService.prototype.editSave = function (data) {
        return Axios.post("supplierclientapi/supplierorgan/update", data);
    };
    SupplierOrganService.prototype.changeStatus = function (data) {
        return Axios.post("supplierclientapi/supplierorgan/change_status", data);
    };
    SupplierOrganService.prototype.cancel = function (data) {
        return Axios.post("supplierclientapi/supplierorgan/delete", data);
    };
    SupplierOrganService.prototype.setDefault = function (data) {
        return Axios.post("supplierclientapi/supplierorgan/set_default", data);
    };
    SupplierOrganService.prototype.getBusiness = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_business_ids", { params: params });
    };
    SupplierOrganService.prototype.bindBusiness = function (data) {
        return Axios.post("supplierclientapi/supplierorgan/bind_business", data);
    };
    SupplierOrganService.prototype.getClientsByGroupTree = function (params) {
        return Axios.get("supplierclientapi/customer/group_childs", { params: params });
    };
    SupplierOrganService.prototype.getSupplier = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_supplier_upper_ids", { params: params });
    };
    SupplierOrganService.prototype.bindSupplier = function (data) {
        return Axios.post("supplierclientapi/supplierorgan/bind_supplier_upper", data);
    };
    SupplierOrganService.prototype.getSuppliersByGroupTree = function (params) {
        return Axios.get("supplierclientapi/supplierupper/group_children", { params: params });
    };
    SupplierOrganService.createInstance = function () {
        SupplierOrganService.getInstance();
    };
    SupplierOrganService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return SupplierOrganService;
}());
export default SupplierOrganService;
